import { Box, Drawer, IconButton, Stack } from "@mui/material";
import { Outlet } from "react-router-dom";
import ConversationThreadsList from "src/components/ConversationThreadsList";
import { useManageDrawer } from "src/hooks/useManageDrawer";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";

const VidaLayout = () => {
  const [open, { handleClose, handleOpen }] = useManageDrawer();
  const DRAWER_WIDTH = 360;

  return (
    <Stack direction={"row"} height="100%">
      <Box
        width="100%"
        sx={{
          transition: (theme) => theme.transitions.create("margin"),
          marginRight: open ? `${DRAWER_WIDTH}px` : 0,
        }}
      >
        <Outlet />
      </Box>
      <Stack>
        <IconButton
          onClick={open ? handleClose : handleOpen}
          sx={{
            position: "absolute",
            top: 16,
            right: open ? DRAWER_WIDTH + 16 : 16,
            zIndex: (theme) => theme.zIndex.drawer + 1,
            transition: (theme) => theme.transitions.create("right"),
          }}
        >
          <ArrowBackIosNewRoundedIcon
            sx={{ transform: open ? "rotate(180deg)" : "none" }}
          />
        </IconButton>
        <Drawer
          open={open}
          anchor="right"
          variant="persistent"
          slotProps={{ paper: { sx: { width: DRAWER_WIDTH } } }}
        >
          <ConversationThreadsList />
        </Drawer>
      </Stack>
    </Stack>
  );
};

export default VidaLayout;
